import { render, staticRenderFns } from "./index.vue?vue&type=template&id=88b18f60&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./css/index.scss?vue&type=style&index=0&id=88b18f60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b18f60",
  null
  
)

export default component.exports